import React, { Component } from "react";
import { connect } from "react-redux";
import { rejectTrainingRequest } from "actions";
import "components/widgets/training/Training.css";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import {Trans} from "react-i18next";
import i18n from "i18next";

class RejectPendingTrainingModal extends Component {
  state = {
    rejectStatus: "init",
    rejectReason: "",
    error: null,
  };

  componentDidMount() {
    console.dir(this.props.training);
  }

  rejectRequest = (reason) => {
    this.props.rejectTrainingRequest(
      this.props.training.recordId,
      this.state.rejectReason,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({ rejectStatus: "success" });
    this.props.refresh();
  };
  onError = (e) => {
    this.props.onProcessEnd();
    console.dir(e);
    this.setState({ rejectStatus: "error", error: e.message });
  };

  renderDescription = () => {
    const { name } = this.props.training.employee;
    const trainingName = this.props.training.training.name;

    //<strong>__employee__</strong> adlı çalışan tarafından <strong>__training__</strong> eğitimine dair talebini reddetmek üzeresiniz.
    // Devam etmek istiyorsanız lütfen aşğıdaki alana red sebebini girerek onay butonuna basınız.
    return (
      <>
        <div dangerouslySetInnerHTML={{__html: i18n.t(10509).replace("__employee__",name).replace("__training__",trainingName)}} />
        <label for="rejectReason" style={{ opacity: "0" }}>
          <Trans desc="Red Sebebi">10510</Trans>
        </label>
        <textarea
          className="pt-reject-reason"
          id="rejectReason"
          type="textarea"
          value={this.state.rejectReason}
          onChange={(e) => this.setState({ rejectReason: e.target.value })}
          rows="4"
          cols="100"
          required
        />
      </>
    );
  };

  renderError = () => {
    return (
      <div className="pt-approve-container">
        <h5><Trans desc="İşlem sırasında bir hata oluştu">10507</Trans></h5>
        <p>{this.state.error}</p>
      </div>
    );
  };

  renderSuccess = () => {
    return (
      <div className="pt-approve-container">
        <h5><Trans desc="İşlem başarılı">10508</Trans></h5>
      </div>
    );
  };

  render() {
    if (this.state.rejectStatus === "init") {
      return (
        <div className="pt-approve-container">
          {this.props.spinner}
          {this.renderDescription()}
          <button
            type="submit"
            className="btn btn-kaydet"
            onClick={() => this.rejectRequest()}
          >
            <Trans desc="Red İşlemini Onayla">10511</Trans>
            
          </button>
        </div>
      );
    } else if (this.state.rejectStatus === "success") {
      return this.renderSuccess();
    } else {
      return this.renderError();
    }
  }
}

export default connect(null, { rejectTrainingRequest })(
  containsLongRunningProcess(RejectPendingTrainingModal)
);
